export default __webpack_public_path__ + "static/media/subscription-success-icon.71bc5a9f.svg";